// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "" + chunkId + ".css?v=" + "e4fbb532d368fdbfb41f" + "";
};